._ClientsView_1or6o_1 {
  /* Empty file & class, used as a placeholder for future styling */
}